import { render, staticRenderFns } from "./ProjectMaterials.vue?vue&type=template&id=bdf7776e&scoped=true"
import script from "./ProjectMaterials.vue?vue&type=script&lang=js"
export * from "./ProjectMaterials.vue?vue&type=script&lang=js"
import style0 from "./ProjectMaterials.vue?vue&type=style&index=0&id=bdf7776e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf7776e",
  null
  
)

export default component.exports